<template>
  <div class="heading-container">
    <div class="col-left">
      {{ label || "-" }}
    </div>
    <div class="col-right">
      <div>{{ user || "-" }}</div>
      <div class="date-value">{{ displayDate }}</div>
    </div>
  </div>
</template>

<script>
import { documentDateFormat } from "@/utils/date";

export default {
  props: {
    label: { type: String, default: null },
    date: { type: String, default: null },
    user: { type: String, default: null }
  },

  computed: {
    displayDate() {
      return this.date ? documentDateFormat(new Date(this.date)) : "-";
    }
  }
};
</script>

<style scoped>
.heading-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.col-left {
  font-size: 1.25rem;
  font-weight: bold;
}

.col-right {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.875rem;
  text-align: right;
}

.date-value {
  color: var(--text-color-dimmed);
}
</style>
